import React, { useCallback } from 'react'
import { DropzoneOptions, useDropzone } from 'react-dropzone'
import { Box, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 600,
    minHeight: 500,
    color: theme.palette.grey['500'],
    fontSize: theme.typography.h6.fontSize,
    cursor: 'pointer',
  },
}))

export type DropzoneProps = {
  id?: string
  label: string
  options?: DropzoneOptions
  onFileDrop: (files: File[]) => void
}

export function Dropzone({
  id,
  label,
  options,
  onFileDrop,
}: DropzoneProps): React.ReactElement {
  const onDrop = useCallback((files: File[]) => onFileDrop(files), [onFileDrop])
  const { getRootProps, getInputProps } = useDropzone({ ...options, onDrop })
  const classes = useStyles()

  return (
    <Box {...getRootProps()}>
      <input id={id} {...getInputProps()} />

      <Box className={classes.dropzone}>{label ?? ''}</Box>
    </Box>
  )
}
